import script from "./InPageSearchBar.vue?vue&type=script&lang=js"
export * from "./InPageSearchBar.vue?vue&type=script&lang=js"

import "./InPageSearchBar.vue?vue&type=style&index=0&id=4a7e71d8&lang=scss"

const __exports__ = script;

export default __exports__